import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

type SigningMethods = 'KAKAO' | 'EMAIL' | 'SECURE_LINK';

interface NewFetchLoginLinkRequest {
  contact: string;
  expiry?: number;
  signingMethod: SigningMethods;
  token: string;
}

const convertToNewRequest = (request: {
  contactInfo: string;
  expiry?: number;
  signingMethodType: 'kakao' | 'KAKAO' | 'email' | 'EMAIL' | 'SECURE_LINK' | 'IN_PERSON';
  token: string;
}): NewFetchLoginLinkRequest => {
  return {
    expiry: request.expiry,
    contact: request.contactInfo,
    signingMethod: request.signingMethodType.toUpperCase() as SigningMethods,
    token: request.token,
  };
};

/**
 *
 * @deprecated Endpoint request is modified in standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#5642fc165133472ebf10425b5437a92a
 */
export function fetchLoginLink({
  contactInfo,
  documentId,
  expiry,
  participantId,
  signingMethodType,
  token,
}: {
  contactInfo: string;
  documentId: string;
  expiry?: number;
  participantId: string;
  signingMethodType: 'kakao' | 'KAKAO' | 'email' | 'EMAIL' | 'SECURE_LINK' | 'IN_PERSON';
  token: string;
}): Promise<{ loginLink: string }> {
  return requestApi<{ loginLink: string }>({
    url: withDocument(`/documents/${documentId}/participants/${participantId}/access`),
    method: 'POST',
    credentials: false,
    data: convertToNewRequest({
      contactInfo,
      expiry,
      signingMethodType,
      token,
    }),
  }).then((response) => response.data);
}
